import { CALL_API } from "../../../middlewares/api";

export const CREATE_LOAN_NOTE_REQUEST = "CREATE_LOAN_NOTE_REQUEST";
export const CREATE_LOAN_NOTE_SUCCESS = "CREATE_LOAN_NOTE_SUCCESS";
export const CREATE_LOAN_NOTE_ERROR = "CREATE_LOAN_NOTE_ERROR";

export function create_loan_note(LoanId, Text) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/add-note",
      method: "POST",
      authenticatedRequest: true,
      data: { LoanId, Text },
      types: [
        CREATE_LOAN_NOTE_REQUEST,
        CREATE_LOAN_NOTE_SUCCESS,
        CREATE_LOAN_NOTE_ERROR,
      ],
    },
  };
}
